import { FC } from 'react';

const iconMapMark = require('./icon_map_mark.svg');

export const IconMapMark: FC = () => {
  return <img alt="icon_map_mark" height={57} src={iconMapMark} width={46} />;
};

IconMapMark.displayName = 'IconMapMark';
